


















import { Component, Vue } from "vue-property-decorator";
import { Modal, Button } from "ant-design-vue";

@Component({
  name: "ModalGlobal",
  components: {
    AModal: Modal,
    AButton: Button
  }
})
export default class ModalGlobal extends Vue {
  private visible = true;
  private title = "提示";
  // private cancelText = "取消";
  private cancelObj: any = {
    text: "取消",
    type: ""
  };
  private okObj: any = {
    text: "确定",
    type: "primary"
  };
  private okText = "确定";
  private cancelLoading = false;

  private ok = function() {
    // default
  };
  private cancel = function() {
    // default
  };

  // 后续可以优化成vnode
  private content: any = "";

  private created() {
    // undo
  }

  private _close() {
    this.visible = false;
  }

  private async _cancel() {
    this.cancelLoading = true;
    this.cancel && (await this.cancel());
    this.cancelLoading = false;
    this._close();
  }

  private async _ok() {
    this.ok && (await this.ok());
    this._close();
  }
}
